/**
 * Wrapper for pixi-particles to make it compatible with gsap.
 *
 * Created: 2017-01-09
 * @author jonas
 */

import {gsap} from "gsap";
import {Emitter, OldEmitterConfig} from "pixi-particles";

export class TweenParticleEmitter extends PIXI.Container {
    private _emitter:Emitter;
    private _totalDuration:number;
    public currentTime:number = 0;
    private _prevTime:number = 0;

    get emitter():Emitter {
        return this._emitter;
    }

    get tween():gsap.core.Tween {
        return this.createTween();
    }

    constructor(textures:PIXI.Texture[], config:OldEmitterConfig) {
        super();
        this._emitter = new Emitter(this, textures, config);
        this._totalDuration = this._emitter.emitterLifetime + this._emitter.maxLifetime;
    }

    private onStart() {
        this._emitter.emit = true;
        this._prevTime = 0;
    }

    private onUpdate() {
        let delta:number = this.currentTime - this._prevTime;
        this._emitter.update(delta);
        this._prevTime = this.currentTime;
    }

    public createTween(ease:any = "none"):gsap.core.Tween {
        this._totalDuration = this._emitter.emitterLifetime + this._emitter.maxLifetime;
        return gsap.fromTo(this, this._totalDuration,
            {currentTime:0},
            {
                currentTime:this._totalDuration,
                ease:ease,
                onStart:() => this.onStart(),
                onUpdate:() => this.onUpdate()
            });
    }


}
